export const DelayEnum = {
  HEADER: 1000,
  RECALCULATION: 2000,
  SUGGESTIONS: 2000,
  TOTAL_PRICE: 500,
  FOOTER: 500,
} as const;
